import useHostname from '@/composables/useHostname';

export default async function (type: string) {
    const { token } = await $fetch<{ token: string }>('/api/swap_portal', {
        method: 'POST',
        body: {
            type,
        },
    });

    const auth = useAuth();
    auth.clearTokens();

    const host = useHostname();
    window.location.href = `//${type}${host.stage}.${host.domain}${import.meta.env.BASE_URL}landing?token=${token}&type=${type}`;
}
